
import { Component, Vue, Prop } from "vue-property-decorator";
const TemplateTransformTwo = () =>
  import("../template-transform/template-transform-two.vue");
@Component({
  components: {
    TemplateTransformTwo,
  },
})
export default class Name extends Vue {
  @Prop()
  private data: any;
  @Prop()
  private ifCompose: any;
  private get c() {
    this.$forceUpdate();
    return this.data;
  }
  private change(ev: any) {
    this.$emit("update", this.c);
  }
  private updateTemplate(item: any) {
    this.c.extra[item.index] = item.data;
  }
}
